/**
 * Design tokens from the UI concept v1 cover (docs/designs/Chapsi-UI-00-Cover.png)
 * and the logo pack v2 (brand/logo/README.txt). Web reads tokens.css; mobile reads this module.
 *
 * The v4 restyle values (type scale, spacing, sizes, radii, shadows, colours) are in v4.ts, the single source for them
 * (docs/adr/0080-v4-tokens-and-page-header.md); the older names below stay for the screens not yet moved over.
 *
 * Rules from the cover:
 *  - Inter for the app UI. Fredoka only for the logo, splash and sign-in, and marketing (v4).
 *  - Brand gradient on primary buttons and progress only.
 *  - Sidebar is Ink; the selected channel is Violet; Orange is the support and attention colour.
 */
export const color = {
    ink: '#0F172A',
    inkSoft: '#1E293B',
    violet: '#7C3AED',
    violetFlat: '#6D3BF0',
    blue: '#2563EB',
    orange: '#FF8A3D',
    pink: '#F05BB5',
    green: '#16A34A',
    red: '#E11D48',
    canvas: '#F8FAFC',
    surface: '#FFFFFF',
    border: '#E2E8F0',
    text: '#0F172A',
    textMuted: '#5E6D83',
    textSubtle: '#627288',
};
export const gradient = {
    brand: 'linear-gradient(90deg, #FF8A3D 0%, #F05BB5 40%, #7C3AED 75%, #2563EB 100%)',
    sunset: 'linear-gradient(135deg, #FF7A3D 0%, #FFB547 100%)',
    ultraviolet: 'linear-gradient(135deg, #C04BF2 0%, #7C3AED 55%, #2563EB 100%)',
};
/** Pill colours for statuses, types and priorities (text on tinted background). */
export const pill = {
    slate: { fg: '#334155', bg: '#E2E8F0' },
    blue: { fg: '#1D4ED8', bg: '#DBEAFE' },
    violet: { fg: '#6D28D9', bg: '#EDE9FE' },
    red: { fg: '#BE123C', bg: '#FFE4E6' },
    green: { fg: '#15803D', bg: '#DCFCE7' },
    orange: { fg: '#C2410C', bg: '#FFEDD5' },
    pink: { fg: '#BE185D', bg: '#FCE7F3' },
};
export const typeColor = { task: 'violet', job: 'blue', support: 'orange', bug: 'red' };
export const priorityColor = { p1: 'red', p2: 'orange', p3: 'slate', p4: 'slate' };
export const font = {
    ui: "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    display: "'Fredoka', 'Inter', ui-sans-serif, sans-serif",
};
export const radius = { sm: 6, md: 10, lg: 14, pill: 999 };
export const space = { 1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 8: 32, 10: 40 };
export const layout = {
    sidebarWidth: 250,
    rightPanelWidth: 330,
    drawerWidth: 440,
    designWidth: 1440,
    minWidth: 1024,
};
export * from './theme.js';
/** Avatar backgrounds, indexed by PersonRef.color (stable per person). Same as the web `.av-N` classes. */
export const avatarPalette = ['#7C3AED', '#2563EB', '#F97316', '#0EA5E9', '#EC4899', '#16A34A', '#9333EA', '#E11D48'];
export * from './contrast.js';
export * from './v4.js';
export * from './notes.js';
//# sourceMappingURL=index.js.map